/** @format */

import template from './gb-template-panel.html';
import './gb-template-panel.scss';

export const GbTemplatePanelComponent = {
    template,
    require: {
        gbApp: '^^',
        gbEditTools: '^^',
    },
    controller: class GbTemplatePanelComponent {
        constructor($gbAuth, $gbProjectorTemplate, $translate, $log, $ccToast, LoadingHelper, $ccLoading, $mdDialog) {
            'ngInject';
            this.$gbAuth = $gbAuth;
            this.$gbProjectorTemplate = $gbProjectorTemplate;
            this.$translate = $translate;
            this.$log = $log;
            this.$ccToast = $ccToast;
            this.$mdDialog = $mdDialog;

            this.loadingHelper = new LoadingHelper();
            this.isLoading = () => this.loadingHelper.isLoading();
            this.getLoadingMessage = () => this.loadingHelper.getFirstMessage();
            this.loadingWatcher = $ccLoading.bind(this.isLoading, this.getLoadingMessage);

            this.image = null;

            this.selectedTemplate;
        }

        close() {
            this.gbEditTools.closeTemplatePanel();
        }

        loadProjector() {}

        getTemplates() {
            return this.$gbProjectorTemplate.cache.query({});
        }

        saveTemplate(templateName) {
            let loader = this.loadingHelper.push('SAVING');

            return this.$gbProjectorTemplate
                .saveProjectorTemplate({
                    projector: this.gbApp.getProjectorId(),
                    name: templateName,
                })
                .$promise.then(() => {
                    let successMessage = this.$translate.instant('TEMPLATE_SAVE_SUCCESS');

                    this.$ccToast.success(successMessage);

                    return this.$gbProjectorTemplate.query().$promise.then((data) => {
                        this.$gbProjectorTemplate.cache.clear();
                        this.$gbProjectorTemplate.cache.push(data);
                    });
                })
                .catch((err) => {
                    this.$ccToast.error(err);
                    throw err;
                })
                .finally(() => {
                    loader();
                });
        }

        promptAndSaveTemplate(ev) {
            return this.showTemplateSavePrompt(ev).then((templateName) => {
                return this.saveTemplate(templateName);
            });
        }

        loadProjectorTemplate(ev) {
            return this.showConfirmLoadMessagesWarning(ev)
                .then(() => {
                    return this.$gbProjectorTemplate.loadProjectorTemplate(
                        {
                            uuid: this.selectedTemplate.uuid,
                        },
                        {
                            auction: this.gbApp.getAuctionUrl(),
                            projector: this.gbApp.getProjectorId(),
                        }
                    );
                })
                .then(() => {
                    let loader = this.loadingHelper.push('LOADING TEMPLATE');
                    this.gbApp.syncingInitial = true;
                    return this.gbApp.initialSync().finally(() => {
                        loader();
                        this.gbApp.syncingInitial = false;
                    });
                })
                .catch((err) => {
                    this.$ccToast.error(err);
                    throw err;
                });
        }

        showConfirmLoadMessagesWarning(ev) {
            let confirmDialog = this.$mdDialog
                .confirm()
                .title(this.$translate.instant('LOAD_TEMPLATE_CONFIRM_HEADING'))
                .textContent(
                    this.$translate.instant('LOAD_TEMPLATE_CONFIRM_DESCRIPTION', {
                        template_name: this.selectedTemplate.name,
                    })
                )
                .targetEvent(ev)
                .ok(this.$translate.instant('LOAD_TEMPLATE_CONFIRM_YES'))
                .cancel(this.$translate.instant('LOAD_TEMPLATE_CONFIRM_NO'));

            return this.$mdDialog.show(confirmDialog);
        }

        showTemplateSavePrompt(ev) {
            let confirm = this.$mdDialog
                .prompt()
                .title(this.$translate.instant('MODAL_PROJECTOR_TEMPLATE_HEADING'))
                .placeholder(this.$translate.instant('MODAL_PROJECTOR_TEMPLATE_NAME'))
                .ariaLabel(this.$translate.instant('MODAL_PROJECTOR_TEMPLATE_NAME'))
                .targetEvent(ev)
                .required(true)
                .ok(this.$translate.instant('MODAL_PROJECTOR_TEMPLATE_SAVE'))
                .cancel(this.$translate.instant('MODAL_PROJECTOR_TEMPLATE_CANCEL'));

            return this.$mdDialog.show(confirm);
        }
    },
};
